module.exports = __webpack_public_path__ + "static/media/construction.57c9515b.jpg";